import * as array from 'fp-ts/Array';
import { flow, pipe } from 'fp-ts/function';
import { sign } from 'fp-ts/Ordering';
import { not } from 'fp-ts/Predicate';
import * as string from 'fp-ts/string';
import { fn } from './function.js';
import * as option from './option.js';
export * from 'fp-ts/string';
export const OrdLocale = {
    equals: string.Eq.equals,
    compare: (first, second) => sign(first.localeCompare(second)),
};
/**
 * Check whether a given search term appears in a string using case-insensitive matching.
 */
export const looseIncludes = (searchString) => (s) => s.toLowerCase().includes(searchString.toLowerCase());
// TODO consider replacing with https://gcanti.github.io/fp-ts-contrib/modules/RegExp.ts.html#match
export const match = (matcher) => (s) => option.fromNullable(s.match(matcher));
/**
 * Create a Monoid instance to join strings using a separator.
 */
export const join = (separator) => ({
    concat: (a, b) => (a === '' || b === '' ? a + b : a + separator + b),
    empty: '',
});
/**
 * Monoid instance to join strings using a space.
 */
export const spaceSeparated = join(' ');
/**
 * Monoid instance to join strings using a semicolon.
 */
export const semicolonSeparated = join('; ');
/**
 * Monoid instance to join strings using a comma.
 */
export const commaSeparated = join(', ');
/**
 * Monoid instance to join strings using a line break.
 */
export const newlineSeparated = join('\n');
/**
 * Check whether a string is whitespace or empty.
 * @see isNotBlank
 */
export const isBlank = flow(string.trim, string.isEmpty);
/**
 * Check whether a string contains non-whitespace characters.
 * @see isBlank
 */
export const isNotBlank = not(isBlank);
/**
 * A version of {@link startsWith} that works with multiple inputs
 */
export const startsWithOneOf = (...searchStrings) => (s) => pipe(searchStrings, array.some((search) => s.startsWith(search)));
/**
 * Generates a hash code from a string.
 * @param str The string to hash
 * @return A 32-bit integer in hexadecimal encoding
 * @see http://werxltd.com/wp/2010/05/13/javascript-implementation-of-javas-string-hashcode-method/
 */
export const hash = (str) => {
    let hash = 0;
    for (let i = 0; i < str.length; i++) {
        const char = str.charCodeAt(i);
        hash = (hash << 5) - hash + char;
        hash = hash & hash; // Convert to 32-bit integer
    }
    return hash.toString(16);
};
export const append = (appended) => (s) => `${s}${appended}`;
export const prepend = (prepended) => (s) => `${prepended}${s}`;
export const splitAt = (i) => (s) => 
//option.when(0 <= i && i <= s.length, () => fn.tuple(s.substring(0, i), s.substring(i)));
fn.tuple(s.substring(0, i), s.substring(i));
export const splitFirst = (separator) => (s) => pipe(option.when(separator.length > 0, () => s.indexOf(separator)), option.filter((i) => 0 <= i), option.fold(() => fn.tuple(s, option.none), (i) => fn.tuple(s.substring(0, i), option.some(s.substring(i + separator.length)))));
export const replaceAll = (searchValue, replaceValue) => (s) => s.replaceAll(searchValue, replaceValue);
export const capitalise = (s) => (s.length === 0 ? s : s.charAt(0).toUpperCase() + s.slice(1));
//# sourceMappingURL=string.js.map